import { Box, Container, Text, Spacer, Button, Image } from 'roadie-ui'
import Page from 'rui/widgets/Page'
import Thin from 'components/layout/Thin'
import getTheAppImage from 'images/gettheapp.png'
import mobileQRCode from 'images/mobileQRCode.png'
import googlePlayBadge from 'images/google-play-badge.png'
import appleStoreBadge from 'images/apple-store-badge.png'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { LocalizedRichText, useLocalization, LocalizedText } from 'localization'

const QRCode = styled.img`
  height: 185px;
`

const GoMobile = () => {
  const { t } = useLocalization()
  const isWebview = useSelector((state) => state.config.isWebview)

  return (
    <Page>
      <Thin>
        <Container.Panel $padding="0" $textAlign="center" $borderStyle={isWebview ? 'none' : 'solid'}>
          <Image src={getTheAppImage} alt="" />
          <Container.Grid $justifyItems="center" $padding="2.4rem 4rem">
            <Text.H5 $fontWeight="bold" $color="neutral-black">
              <LocalizedText translationKey="dweb_go_mobile_get_app" />
            </Text.H5>
            <Spacer $height=".8rem" />
            <Box.Simple $maxWidth={isWebview ? '28rem' : '32rem'}>
              <Text.Body2 $color="neutral-black">
                <LocalizedRichText
                  translationKey="dweb_go_mobile_youll_need_inline_text1_app_complete_registration_please"
                  params={{
                    inlineText1: (
                      <Text.Body2 baseElement="span" $fontWeight="bold" $color="neutral-black">
                        <LocalizedText translationKey="dweb_go_mobile_roadie_driver" />
                      </Text.Body2>
                    ),
                  }}
                />
              </Text.Body2>
            </Box.Simple>
            <Spacer $height="3.2rem" />
            <QRCode src={mobileQRCode} alt={t('dweb_go_mobile_qr_code_mobile_app')} />
            <Spacer $height="3.2rem" />
            <Container.Grid $gridTemplateColumns="1fr 1fr">
              <Button.A.Tertiary href="https://apps.apple.com/us/app/roadie-driver/id1436325695">
                <Image src={appleStoreBadge} $maxHeight="4rem" alt={t('dweb_go_mobile_apple_store_badge')} />
              </Button.A.Tertiary>
              <Button.A.Tertiary href="https://play.google.com/store/apps/details?id=com.roadie.drive.android.app&hl=en_US&gl=US">
                <Image src={googlePlayBadge} $maxHeight="4rem" alt={t('dweb_go_mobile_google_play_badge')} />
              </Button.A.Tertiary>
            </Container.Grid>
          </Container.Grid>
        </Container.Panel>
      </Thin>
    </Page>
  )
}

export default GoMobile
